import { TableSkeleton } from '@/components/shared/skeleton'

export const UserContactsListSkeleton = () => (
  <TableSkeleton rows={7} itemClassName="h-[68px] rounded-24 sm:mb-8" />
)
